import React, { Component } from "react";
import NavEN from "../Symbols/NavEN";
import FooterEN from "../Symbols/FooterEN";
import "../../stylesheets/Kontakt.css";
import Ref1 from "../../assets/ref_1.png";
import { Helmet } from "react-helmet-async";

class ReferencesEN extends Component {
  constructor(props) {
    super(props);
    this.intro = React.createRef();
  }

  introScroll = () => {
    let element = this.intro.current;
    let headerOffset = 45;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - References</title>
          <meta
            name="description"
            content="Discover exciting references from Pancon - innovative solutions
solutions, successfully implemented projects, satisfied customers and distributors.
Let us convince you of our competence and experience!"
          />
          <meta property="og:title" content="Pancon - References" />
          <meta
            property="og:description"
            content="Discover exciting references from Pancon - innovative solutions
solutions, successfully implemented projects, satisfied customers and distributors.
Let us convince you of our competence and experience!"
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/referenzen"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/references"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavEN />
        <div className="hero ref">
          <div className="red-bg-hero"></div>
          <div className="hero-content">
            <h1 className="hero-heading">References</h1>
            <p className="hero-desc">Our partners</p>
            <button onClick={this.introScroll} className="default inverted">
              Learn more
            </button>
          </div>
        </div>
        <div
          ref={this.intro}
          className="section flex first intro center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2>References</h2>
              <img src={Ref1}></img>
            </div>
          </div>
        </div>
        <FooterEN />
      </div>
    );
  }
}

export default ReferencesEN;
